import { FunctionalReducer, IReducerAction } from 'app/redux/FunctionalReducer'
import { Profile } from 'app/redux/Profile/model'
import { FamilyInfoService } from 'app/services/FamilyInfoService'
import { OperationStatus } from 'app/services/OperationStatus'
import ImmutableMap from 'app/utils/immutable/map'
import { getWebServicesConfig } from 'config'
import * as _ from 'lodash'
import * as Redux from 'redux'

interface IProfileState {
  op: OperationStatus
  info?: Profile
}

interface IProfileAction extends IReducerAction {
  type: string
  profile?: IProfileState
}

const ActionTypes = {

  PROFILE_RETRIEVAL_STARTING: 'profile/RETRIEVAL_STARTING',
  PROFILE_RETRIEVAL_COMPLETED: 'profile/RETRIEVAL_COMPLETED',
  PROFILE_RETRIEVAL_FAILED: 'profile/RETRIEVAL_FAILED',

  PROFILE_STORE_STARTING: 'profile/STORE_STARTING',
  PROFILE_STORE_COMPLETED: 'profile/STORE_COMPLETED',
  PROFILE_STORE_FAILED: 'profile/STORE_FAILED'
}

const initialState = new ImmutableMap<IProfileState>({
  op: new OperationStatus(),
  info: undefined
})

const ProfileReducer = new FunctionalReducer<ImmutableMap<IProfileState>, IProfileAction>(initialState)
  .whenTypeIs([ActionTypes.PROFILE_RETRIEVAL_COMPLETED, ActionTypes.PROFILE_STORE_STARTING], (state, action) => {
    // tslint:disable-next-line:no-console
    //console.log('profile action: ' + JSON.stringify(action, undefined, 4))
    return state.update({
      info: action.profile.info,
      op: action.profile.op,
    })
  })
  .whenTypeIs(ActionTypes.PROFILE_STORE_COMPLETED, (state, action) => {
    return state.update({
      op: action.profile.op,
    })
  })
  .whenTypeIs([ActionTypes.PROFILE_RETRIEVAL_FAILED, ActionTypes.PROFILE_STORE_FAILED], (state, action) => {
    return state.update({
      op: action.profile.op,
    })
  })

export {
  ProfileReducer,
  ActionTypes,
  IProfileState,
  IProfileAction
}



// WEBPACK FOOTER //
// ./src/app/redux/Profile/reducer/index.ts